// extracted by mini-css-extract-plugin
module.exports = {"rankings-header":"_9hhLDKt8XuwOdWsRmzE7"};